import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'homePage',
      component: resolve => require(['../pages/home.vue'], resolve),
      children: [
        {
          path: '/',
          name: 'homePage',
          component: resolve => require(['../pages/homePage.vue'], resolve)
        },
        {
          path: '/productCenter',
          name: 'productCenter',
          component: resolve => require(['../pages/productCenter.vue'], resolve)
        },
        {
          path: '/drive',
          name: 'drive',
          component: resolve => require(['../pages/productCenter/drive.vue'], resolve)
        },
        {
          path: '/fordinner',
          name: 'fordinner',
          component: resolve => require(['../pages/productCenter/fordinner.vue'], resolve)
        },
        {
          path: '/store',
          name: 'store',
          component: resolve => require(['../pages/productCenter/store.vue'], resolve)
        },
        {
          path: '/materiel',
          name: 'materiel',
          component: resolve => require(['../pages/productCenter/materiel.vue'], resolve)
        },
        {
          path: '/kds',
          name: 'kds',
          component: resolve => require(['../pages/productCenter/kds.vue'], resolve)
        },

        {
          path: '/businessIntroduction',
          name: 'businessIntroduction',
          component: resolve => require(['../pages/businessIntroduction.vue'], resolve)
        },
        {
          path: '/aboutUs',
          name: 'aboutUs',
          component: resolve => require(['../pages/aboutUs.vue'], resolve)
        },
        {
          path: '/industryConsult',
          name: 'industryConsult',
          component: resolve => require(['../pages/industryConsult/industryConsult.vue'], resolve)
        }
      ]
    },
    {
      path: '/consult',
      name: 'consult',
      component: resolve => require(['../pages/industryConsult/consult.vue'], resolve)
    },
    {
      path: '/login',
      name: 'login',
      component: resolve => require(['../pages/login.vue'], resolve)
    },
    {
      path: '/register',
      name: 'register',
      component: resolve => require(['../pages/register.vue'], resolve)
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js